import * as TYPES from './pageListBlockTypes';

const initialState = {
  isLoading: false,
  items: [],
  selectedIndex: undefined,
  currentPageId: undefined,
  lastPageId: undefined,
  lastUpdatedCategory: undefined,
  progress: 0,
  error: {
    hasError: false,
    message: ''
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.PAGE_LIST_BLOCK_FETCH: {
      return {
        ...state,
        isLoading: true,
        progress: 25,
        lastUpdatedCategory: action.category
      };
    }
    case TYPES.PAGE_LIST_BLOCK_FETCHED: {
      return {
        ...state,
        isLoading: false,
        items: action.items,
        error: { hasError: false, message: '' },
        progress: 100
      };
    }
    case TYPES.PAGE_LIST_BLOCK_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: { hasError: true, message: action.message }
      };
    }
    case TYPES.PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGE: {
      return {
        ...state
      };
    }
    case TYPES.PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGED: {
      return {
        ...state,
        lastPageId: state.currentPageId,
        selectedIndex: action.index,
        currentPageId: action.id
      };
    }
    default:
      return state;
  }
};
